/**
 * @description constants used by the module
 */

// Contains a static list of statuses for each personnel assigned to the contract
// eslint-disable-next-line import/prefer-default-export
export const STATUSES = [
  { label: 'Pending Assigned', value: 'Pending Assigned' },
  { label: 'Assigned', value: 'Assigned' }
];
